import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import React, { useEffect, useState } from 'react'

import Button from 'components/Button'
import AlarmOn from 'components/icons/Alarm_On'
import LocationIcon from 'components/icons/LocationIcon'
import PaymentIcon from 'components/icons/PaymentIcon'

import CapIcon from 'components/icons/CapIcon'
import CheckTick from 'components/icons/CheckCircleIcon'

import ConfirmDrawer from './ConfirmDrawer'

import { LoginOutlined } from '@ant-design/icons'
import { Col, message, Row, Tooltip } from 'antd'
import ConfirmationModal from 'components/ConfirmationModal'
import CandidatesIcon from 'components/icons/CandidatesIcon'
import SaveFilled from 'components/icons/SaveFilled'
import SaveOutLine from 'components/icons/SaveOutLine'
import SuccessModal from 'components/SuccessModal'
import WorkExperienceDrawer from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExperienceDrawer'
import {
  Address,
  ApplyButton,
  ApplyText,
  BodyText,
  CompanyName,
  CTCDiv,
  CTCRow,
  LapsedButton,
  LogoWrapper,
  Name,
  NameAdd,
  NameAdd2,
  RightDivStatus,
  RoleNameDiv,
  StyledFlex,
  StyledRow,
  TabCount,
  Wrapper1,
} from 'modules/Roles/Style/style'
import Moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { formatNumber } from 'utils/formatNumber'
import { checkJobCategory } from '../../../utils/const'
import { getAppliedRoleMetrics } from '../../Applied_Roles/actions'
import CustomModal from './CustomModal'
import SkillBasedRoleDrawer from './SkillBasedRoleDrawer'
const SuccessMessage = description =>
  message.success({
    content: (
      <div
        style={{
          background: '#FAFDFC',
        }}
      >
        <Flex>
          <Avatar size={25} src={<CheckTick />} />
          <NameAdd column flexStart>
            <Name>Applied Successfully</Name>

            <Address>For the Role '{description}'</Address>
          </NameAdd>
        </Flex>
      </div>
    ),
    className: 'custom-class',
    icon: PaymentIcon,
    style: {
      transitionDuration: '5s',
    },
  })

const SingleListed = ({
  DataList,
  ApplyRole,
  SaveRole,
  getSingleRoleDetails,
  getEligibleDetails,
  getRoleFloatDetails,
  collegeData,
  getFunctionsList,
  functionsList,
  updateStudentData,
  studentDetails,
  getListOfSkills,
  updateRoleFloatDetails,
  UpdatedSkills,
  getRolesList,
  studentData,
  fetchRoleListData,
  roleTypewithComp,
  updateStudent,
  studentFullRules,
  exceptionBrand,
  fetchStudentRuleSet,
  optOutStatus,
}) => {
  const navigate = useNavigate()
  const dispatch = new useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [selected, setSelected] = useState({})
  const [selectedNew, setSelectedNew] = useState({})
  const [collegeTier, setCollegeTier] = useState()
  const [workExperienceDrawer, setWorkExperienceDrawer] = useState(false)
  const listOfStudentSkills = []
  const [roleDrawer, setRoleDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [skillVisible, setSkillVisible] = useState(false)
  const [locationVisible, setLocationVisible] = useState(false)
  const [expVisible, setExpVisible] = useState(false)
  const [expDrawer, setExpDrawer] = useState(false)
  const [updateResponse, setUpdateResponse] = useState(false)
  const [questionnaireModal, setQuestionnaireModal] = useState(false)
  const [applyBeforeConfirm, setApplyBeforeConfirm] = useState(false)
  const [appliedSuccessModal, setAppliedSuccessModal] = useState(false)
  const [selectedRoleDetails, setSelectedRoleDetails] = useState(null)
  const [externalConfirm, setExternalConfirm] = useState(false)
  const [externalLinkApply, setExternalLinkApply] = useState(false)
  const corporateIds = exceptionBrand?.map(item => item?.corporateId)
    const campusDetails = useSelector(state => state?.studentData?.campusDetails)
    const accessLevel = campusDetails?.instituteSubscription?.accessLevel
  const openModal = async () => {
    setModalVisible(false)
    showDrawerNew(selected?.id)
    setSelectedNew(selected)
    const itemId = selected?.id
    let res = await getEligibleDetails({ roleID: itemId, setLoading })
    if (res?.skills?.isEligible) {
      setSkillVisible(true)
      setUpdateResponse(true)
    }
    if (res?.locations?.isEligible) {
      setLocationVisible(true)
    }
    if (res?.experience?.isEligible) {
      setExpVisible(true)
    }

    getRoleFloatDetails({ setLoading })
    setRoleDrawer(true)
  }

  const closeModal = () => {
    setModalVisible(false)
  }
  const closeQuestionnaireModal = () => {
    setQuestionnaireModal(false)
    UpdatedSkills()
  }
  const openQuestinnaire = () => {
    // setQuestionnaireModal(false)
    navigate(
      `/roles/viewRole/${selected?.corporate?.id || selected?.company?.id}/${
        selected?.id
      }/questionnaire`
    )
  }
 
  const onConfirmModalClose = async () => {
    setApplyBeforeConfirm(false)
    //  setAppliedSuccessModal(false)
    setExternalConfirm(false)
  }

  const onCloseCofirmApplied = () => {
    setApplyBeforeConfirm(false)
    setAppliedSuccessModal(false)
    setExternalConfirm(false)
    fetchRoleListData()
    fetchStudentRuleSet()

    dispatch(getAppliedRoleMetrics())
  }
  const onExternalApplyClose = async () => {
    setExternalLinkApply(false)
    await updateStudent({ lastAppliedJobIds: [] })
  }
  const onRoleAccept = () => {
    setApplyBeforeConfirm(false)
    onApplyClick(selectedRoleDetails)
  }
  const onExternalRedirect = async () => {
    let link = selectedRoleDetails?.externalLink
    if (
      !selectedRoleDetails?.externalLink.startsWith('http://') &&
      !selectedRoleDetails?.externalLink.startsWith('https://')
    ) {
      link = 'https://' + selectedRoleDetails?.externalLink
    }

    const newTab = window.open('', '_blank')

    setTimeout(() => {
      newTab.location.href = link
    }, 100)
    await updateStudent({ lastAppliedJobIds: [selectedRoleDetails?.id] })

    setExternalConfirm(false)
    setExternalLinkApply(true)
  }
  const onExternalApply = async () => {
    onApplyClick(selectedRoleDetails)
    await updateStudent({ lastAppliedJobIds: [] })

    setExternalLinkApply(false)
  }
  const eligibleList = useSelector(
    state => state?.rolesListData.eligibleDetails
  )
  const roleFloatList = useSelector(
    state => state?.rolesListData.roleFloatDetails
  )

  useEffect(() => {
    setCollegeTier('tier' + collegeData?.institute?.tier)
  }, [collegeData])

  const CheckIcon = item => {
    // if (!logo) {
    //   return (
    //     <Avatar
    //       size={65}
    //       src={<ApartmentIcon />}
    //       boxShadow={true}
    //       padding={'3px'}
    //       shape={"square"}
    //     />
    //   )
    // } else {
    return (
      <Avatar
        size={65}
        src={item?.corporate?.logo ?? item?.companyLogo?.url}
        IconName={
          item?.corporate?.name?.split('')[0]?.toUpperCase() ??
          item?.companyName?.split('')[0]?.toUpperCase()
        }
        shape={'square'}
      />
    )
    // }
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const checkDate = date => {
    return Moment.utc(date).format('MMM DD') // Ensure UTC is used
  }
  const getCategoryDetails = (
    minCompensation,
    maxCompensation,
    jobCategory
  ) => {
    if (roleTypewithComp?.length === 0 || jobCategory != 'PLACEMENT') {
      return { orderNo: null, name: null } // Return null for both if no roleTypewithComp? exist
    }

    let matchingCategory = roleTypewithComp?.find(
      category =>
        maxCompensation >= category.minCTC &&
        maxCompensation <= (category.maxCTC || Number.MAX_SAFE_INTEGER)
    )

    if (matchingCategory) {
      return { orderNo: matchingCategory.orderNo, name: matchingCategory.name }
    }

    return { orderNo: null, name: null }
  }
  // const showApply = (data) => {
  //   if (data?.status == -1) {
  //     return <Button.Danger text={'Cancelled'} />
  //   }
  //   else if (!data?.isExpired){
  //     return <Button.SecondaryColor text={'Apply'} width={'120px'} />
  //   }
  //   else{
  //     return <Button.SecondaryColor text={'Apply'} width={'120px'} />
  //   }
    
  // }
  const DateCompare = data => {
    if (data?.status == -1) {
      return <Button.Danger text={'Cancelled'} />
    } else if (
      data?.isEligible &&
      data?.isExternalLink &&
      data?.roleStatus == 'REQ.APPROVED'
    ) {
      return (
        <Button.Primary
          onClick={() => viewRoles(data)}
          color={'#3249D7'}
          background={'#EAEDFB'}
          icon={
            <span style={{ marginLeft: '7px' }}>
              <LoginOutlined />
            </span>
          }
          text={`Apply  ` + '   '}
          width={'80px'}
          disabled={(accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4}
          //Flow Changed
          // disabled={
          //   studentData?.status == -1 ||
          //   optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 1 ||
          //   optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 4
          // }
        />
      )
    } else if (
      data?.jobRoleStudentMap?.[0]?.tpoStatus === 0 &&
      !data?.isExpired
    ) {
      return <Button.SecondaryColor text={'Approval Sent'} width={'130px'} />
    } else if (
      data?.jobRoleStudentMap?.[0]?.tpoStatus === 0 &&
      data?.isExpired
    ) {
      return <LapsedButton width={'130px'}>{'Approval Lapsed'}</LapsedButton>
    } else if (data?.jobRoleStudentMap?.[0]?.tpoStatus === -1) {
      return (
        <LapsedButton width={'130px'} background={'#FFEEEC'} color={'#E35E50'}>
          {'Approval Declined'}
        </LapsedButton>
      )
    } else if (!data?.isExpired) {
      if (data?.jobRoleStudentMap?.[0]?.isApplied === -1) {
        return <Button.SecondaryColor text={'Applied'} width={'120px'} />
      } else if (
        (!data?.isEligible ||
          data?.isRestricted ||
          !studentFullRules?.isApplyLimitAvailable ||
          !studentFullRules?.isInitialMissed ||
          !studentFullRules?.isMissedEvaluation) &&
        (data?.jobCategory === 'PLACEMENT' || !data?.isEligible)
      ) {
        // if(data?.externalLink){
        //   return (
        //     <Button.Primary
        //       onClick={() => viewRoles(data)}
        //       color={'#3249D7'}
        //       background={'#EAEDFB'}
        //       icon={
        //         <span style={{ marginLeft: '7px' }}>
        //           <LoginOutlined />
        //         </span>
        //       }
        //       text={`Apply  ` + '   '}
        //       width={'80px'}
        //       disabled={(accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4}
        //     />
        //   );
        // }
        // else{
          return (
          <Button.Primary
            onClick={() => viewRoles(data)}
            color={'#3249D7'}
            background={'#EAEDFB'}
            text={(accessLevel === 1 || accessLevel === 3) ? 'Check\nEligibility' : 'Apply'}
           // text={'Apply'}
            width={'80px'}
            style={{
              whiteSpace: 'pre-line',
              lineHeight: '1.2',
              textAlign: 'center',
            }}
            disabled={
              studentData?.status == -1 ||
              optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 1 ||
              optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 4 ||
              (accessLevel === 1 || accessLevel === 3) &&studentData?.currentState < 4}
          />
        
        )
      // }
      } else {
        if (data?.externalLink) {
          return (
            <Button.Primary
              onClick={() => viewRoles(data)}
              color={'#3249D7'}
              background={'#EAEDFB'}
              icon={
                <span style={{ marginLeft: '7px' }}>
                  <LoginOutlined />
                </span>
              }
              text={`Apply  ` + '   '}
              width={'80px'}
              disabled={
                studentData?.status == -1 ||
                optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 1 ||
                optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 4 ||
                (accessLevel === 1 || accessLevel === 3) &&studentData?.currentState < 4}
            />
          )
        } else {
          return (
            <Button.Primary
              onClick={() => viewRoles(data)}
              color={'#3249D7'}
              background={'#EAEDFB'}
              text={'Apply'}
              width={'80px'}
              disabled={
                studentData?.status == -1 ||
                optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 1 ||
                optOutStatus?.optoutStatus?.currentCourse?.optOutStatus == 4 ||
                ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)
              }
            />
          )
        }
      }
    } else {
      return <Button.Danger text={'Closed'} />
    }
  }
  const checkCity = cityList => {
    if (!cityList || cityList.length === 0) {
      return '-'
    }

    // Fallback to `state_name` if `name` is not available
    const displayName = city => city?.name || city?.state_name || ''

    const resultFull = cityList.map(displayName).filter(Boolean).join(', ')

    let resultShort = cityList
      .slice(0, 3)
      .map(displayName)
      .filter(Boolean)
      .join(', ')

    if (cityList.length > 3) {
      resultShort += `, +${cityList.length - 3}`
    }

    return (
      <div>
        <Tooltip title={resultFull}>{resultShort}</Tooltip>
      </div>
    )
  }

  const onApplyClick = async param => {
    //data
    let payload = {
      id: param?.id,
      corporateId: param?.corporate?.id ?? param?.company?.id,
    }
    const roleAppliedResult = await ApplyRole(payload, false, false)
    if (roleAppliedResult?.status == 201) {
      setAppliedSuccessModal(true)
    }
  }
  const onApplyClickSkilled = param => {
    if (param?.questionBankId) {
      setQuestionnaireModal(true)
    } else {
      if (param?.externalLink) {
        setExternalConfirm(true)
        setSelectedRoleDetails(param)
      } else {
        setApplyBeforeConfirm(true)
        setSelectedRoleDetails(param)
      }
      ///onApplyClick(param)
    }
  }
  const showDrawer = param => {
    setSelectedRoleDetails(null)
    if (param?.isEligible) {
      //questionBankId
      if (param?.questionBankId) {
        setQuestionnaireModal(true)
      } else {
        if (param?.externalLink) {
          setExternalConfirm(true)
          setSelectedRoleDetails(param)
        } else {
          setApplyBeforeConfirm(true)
          setSelectedRoleDetails(param)
        }
        ///onApplyClick(param)
      }

      setSelected(param)
    } else {
      setSelected(param)
      setModalVisible(true)
    }
  }

  const showDrawerNew = param => {
    setSelected(param)
  }

  const HeartClicked = async (event, param) => {
    let payLoad = {
      id: param?.id,
      isSaved: param?.jobRoleStudentMap[0]?.isSaved == 1 ? 0 : 1,
    }

    await SaveRole(payLoad)
    fetchRoleListData()
  }

  const viewRoles = param => {
    navigate(
      `/roles/viewrole/${param?.corporate?.id || param?.companyId}/${param.id}`
    )
  }
  const checkRange = value => {
    if (value?.CTCIsTierBased) {
      let obj = value?.CTC.find(val => {
        return val.name == collegeTier
      })
      if (obj) {
        if (obj?.isRange) {
          return `${formatNumber(obj?.min)} - ${formatNumber(obj?.max)}`
        }
        return `${formatNumber(obj?.max)}`
      }
      return `${formatNumber(value?.maxCompensation)}`
    }
    return `${formatNumber(value?.maxCompensation)}`
  }

  function formatCurrency(amount, keyData) {
    if (amount < 100000) {
      // For amounts less than 1 lakh, convert to K (thousands)
      return `${(amount / 1000).toFixed(2)}K ${keyData}`
    } else {
      // For amounts equal to or more than 1 lakh, convert to L (lakhs)
      return `${(amount / 100000).toFixed(2)} L${
        keyData == 'PM' ? ' PM' : 'PA'
      }`
    }
  }
  const getOrderBasedColor = orderNo => {
    switch (orderNo) {
      case 1:
        return {
          color: '#000000',
          borderColor: '#CCCCCC',
          background: '#CCCCCC33', // 20% opacity of #CCCCCC
        }
      case 2:
        return {
          color: '#000000',
          borderColor: '#97CADB',
          background: '#97CADB33', // 20% opacity of #97CADB
        }
      case 3:
        return {
          color: '#000000',
          borderColor: '#B5A3F7',
          background: '#B5A3F733', // 20% opacity of #B5A3F7
        }
      case 4:
        return {
          color: '#000000',
          borderColor: '#E1A7BA',
          background: '#E1A7BA33', // 20% opacity of #E1A7BA
        }
      case 5:
        return {
          color: '#000000',
          borderColor: '#F29F05',
          background: '#F29F0533', // 20% opacity of #F29F05
        }
      case 6:
        return {
          color: '#000000',
          borderColor: '#F25C05',
          background: '#F25C0533', // 20% opacity of #F25C05
        }
      case 7:
        return {
          color: '#000000',
          borderColor: '#72B06F',
          background: '#72B06F33', // 20% opacity of #72B06F
        }
      case 8:
        return {
          color: '#000000',
          borderColor: '#4C1D91',
          background: '#4C1D9133', // 20% opacity of #4C1D91
        }
      case 9:
        return {
          color: '#000000',
          borderColor: '#02457A',
          background: '#02457A33', // 20% opacity of #02457A
        }
      case 10:
        return {
          color: '#000000',
          borderColor: '#595F33',
          background: '#595F3333', // 20% opacity of #595F33
        }
      default:
        return {
          // Default style for unmatched cases
          color: '#000000',
          borderColor: '#DBDBDB',
          background: '#DBDBDB33', // 20% opacity of #DBDBDB
        }
    }
  }
  return (
    <>
      {DataList?.result?.map((item, index) => {
        //jobCategory
        const categoryDetails = getCategoryDetails(
          item?.minCompensation,
          item?.maxCompensation,
          item?.jobCategory
        )
        return (
          <StyledFlex
            spaceBetween
            centerVertically
            isDisplay={true}
            border={
              corporateIds?.includes(item?.corporate?.id || item?.companyId) &&
              item?.jobCategory === 'PLACEMENT'
                ? '#349DBE'
                : null
            }
            background={
              corporateIds?.includes(item?.corporate?.id || item?.companyId) &&
              item?.jobCategory === 'PLACEMENT'
                ? '#349DBE1A'
                : null
            }
            key={index + 'result'}
          >
            <StyledRow>
              <Col span={9}>
                <Wrapper1 style={{ paddingTop: '8px' }}>
                  <LogoWrapper>{CheckIcon(item)}</LogoWrapper>
                  <NameAdd2>
                    {item?.isNewRole && <TabCount>New</TabCount>}
                    <Tooltip title={item?.tittle}>
                      <RoleNameDiv onClick={event => viewRoles(item)}>
                        {' '}
                        {item?.tittle}
                      </RoleNameDiv>
                    </Tooltip>
                    <CompanyName>
                      from{' '}
                      <span>{item?.corporate?.name ?? item?.companyName}</span>
                    </CompanyName>
                  </NameAdd2>
                </Wrapper1>
              </Col>
              <Col span={10}>
                <Row>
                  <Col span={8}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        src={<CandidatesIcon />}
                        style={{ marginRight: '5px' }}
                      />
                      <BodyText>
                        {/* {item?.rolePublishedBy === 'INSTITUTE'
                          ? checkJobCategory(item?.jobCategory)
                          : checkJobTypeLevel(
                              item?.jobTypeLevels,
                              item?.yearOfExperience
                            )} */}
                            {checkJobCategory(item?.jobCategory)}
                      </BodyText>
                    </div>
                  </Col>

                  <Col span={8}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        src={<CapIcon />}
                        style={{ marginRight: '3px' }}
                      />
                      <BodyText>
                        {' '}
                        {item?.jobTypeLevels?.[0] == 'ENTRY' ||
                        item?.jobTypeLevels?.[0] == 'INTERN'
                          ? 'Freshers'
                          : item?.jobTypeLevels?.[0] == 'BOTH'
                          ? 'Both'
                          : item?.jobTypeLevels?.[0] == 'EXPERIENCED'
                          ? 'Experienced'
                          : ''}
                      </BodyText>
                    </div>
                  </Col>

                  <Col span={8}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        src={<AlarmOn />}
                        style={{ marginRight: '5px' }}
                      />
                      <BodyText>
                        {item?.jobType === 'FULL_TIME'
                          ? 'Full Time'
                          : 'Part Time'}
                      </BodyText>
                    </div>
                  </Col>
                </Row>

                <CTCRow
                  key={index}
                  orderNo={
                    corporateIds?.includes(
                      item?.corporate?.id || item?.companyId
                    ) && item?.jobCategory === 'PLACEMENT'
                      ? 11
                      : categoryDetails.orderNo
                  }
                >
                  <Flex centerVertically>
                    <CTCDiv>
                      <Avatar
                        src={
                          <PaymentIcon
                            color={
                              corporateIds?.includes(
                                item?.corporate?.id || item?.companyId
                              ) && item?.jobCategory === 'PLACEMENT'
                                ? '#DBDBDB'
                                : getOrderBasedColor(categoryDetails.orderNo)
                                    .borderColor
                            }
                          />
                        }
                        style={{ paddingTop: '7px' }}
                      />
                      {item?.stipend === false ||
                      (item?.minCompensation == 0 &&
                        item?.maxCompensation == 0) ? (
                        <span>No Stipend</span>
                      ) : (
                        <>
                          &nbsp;{' '}
                          {(item?.jobCategory === 'INTERNSHIP' ||
                            item?.jobCategory === 'APPRENTICESHIP') &&
                          item?.minCompensation != 0 &&
                          item?.maxCompensation != 0
                            ? 'Stipend'
                            : 'CTC'}{' '}
                          <span>
                            &nbsp;
                            {item?.minCompensation === item?.maxCompensation ? (
                              <span>
                                {`₹${formatCurrency(
                                  Number(item?.minCompensation),
                                  item?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                                )}`}
                              </span>
                            ) : (
                              <span>
                                {`₹${formatCurrency(
                                  Number(item?.minCompensation),
                                  item?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                                )}  - ₹${formatCurrency(
                                  Number(item?.maxCompensation),
                                  item?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                                )}`}
                              </span>
                            )}
                          </span>
                        </>
                      )}
                    </CTCDiv>
                    {corporateIds?.includes(
                      item?.corporate?.id || item?.companyId
                    ) &&
                      item?.jobCategory === 'PLACEMENT' && (
                        <RightDivStatus color={'#D5D5D5'} border={'#000000'}>
                          Excep. Brand
                        </RightDivStatus>
                      )}
                    {!corporateIds?.includes(
                      item?.corporate?.id || item?.companyId
                    ) &&
                      categoryDetails?.name && (
                        <RightDivStatus
                          color={
                            getOrderBasedColor(categoryDetails.orderNo)
                              .borderColor
                          } // Assuming getOrderBasedColor returns the style based on the orderNo
                        >
                          {categoryDetails?.name}
                        </RightDivStatus>
                      )}
                  </Flex>
                </CTCRow>
                <Row style={{ marginTop: '12px', marginBottom: '-12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      src={<LocationIcon />}
                      style={{ marginRight: '3px' }}
                    />
                    <BodyText>
                      {item?.isAnyWhere ? 'Anywhere' : checkCity(item?.cities)}
                    </BodyText>
                  </div>
                </Row>
              </Col>
              <Col span={5} style={{ width: '100%', direction: 'rtl' }}>
                <Row>
                  <ApplyText>
                    Apply before <span>{checkDate(item?.endDate)}</span>
                  </ApplyText>
                </Row>
                <ApplyButton>
                  <div style={{ paddingTop: '10px' }}>
                    {item?.jobRoleStudentMap?.[0]?.isSaved === 1 ? (
                      <SaveFilled
                        onClick={event => HeartClicked(event, item)}
                      />
                    ) : (
                      <SaveOutLine
                        onClick={event => HeartClicked(event, item)}
                      />
                    )}
                  </div>
                  &nbsp; &nbsp; &nbsp; &nbsp;{'  '}
                  {item?.jobRoleStudentMap?.[0]?.isApplied != 1 ? (
                    DateCompare(item)
                  ) : (
                    <Button.SecondaryColor text={'Applied'} width={'120px'} />
                  )}
                </ApplyButton>
              </Col>
              　　 　 　
            </StyledRow>
          </StyledFlex>
        )
      })}

      {modalVisible && (
        <CustomModal
          visible={modalVisible}
          onClose={closeModal}
          onUpdate={openModal}
          message="You are not eligible for this role !"
        />
      )}
      {questionnaireModal && (
        <CustomModal
          visible={questionnaireModal}
          onClose={closeQuestionnaireModal}
          onUpdate={openQuestinnaire}
          isEligible={true}
        />
      )}
      {drawer && (
        <ConfirmDrawer
          drawer={drawer}
          setDrawer={setDrawer}
          dataSelected={selected}
          onApplyClick={onApplyClick}
          getSingleRoleDetails={getSingleRoleDetails}
          collegeTier={collegeTier}
        />
      )}

      {roleDrawer && (
        <SkillBasedRoleDrawer
          setSelected={setSelected}
          setRoleDrawer={setRoleDrawer}
          setSkillVisible={setSkillVisible}
          setLocationVisible={setLocationVisible}
          setExpVisible={setExpVisible}
          skillVisible={skillVisible}
          locationVisible={locationVisible}
          expVisible={expVisible}
          roleDrawer={roleDrawer}
          eligibleList={eligibleList}
          roleFloatList={roleFloatList}
          setWorkExperienceDrawer={setWorkExperienceDrawer}
          getFunctionsList={getFunctionsList}
          getEligibleDetails={getEligibleDetails}
          updateRoleFloatDetails={updateRoleFloatDetails}
          UpdatedSkills={UpdatedSkills}
          loading={loading}
          setLoading={setLoading}
          getRolesList={getRolesList}
          itemId={selected}
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          getListOfSkills={getListOfSkills}
          setUpdateResponse={setUpdateResponse}
          updateResponse={updateResponse}
          setQuestionnaireModal={setQuestionnaireModal}
          selectedNew={selectedNew}
          onApplyClick={onApplyClickSkilled}
        />
      )}

      {workExperienceDrawer && (
        <WorkExperienceDrawer
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={workExperienceDrawer}
          setdrawerStatus={setWorkExperienceDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
        />
      )}
      <ConfirmationModal
        onCloseClick={() => onConfirmModalClose()}
        open={applyBeforeConfirm}
        description={
          studentFullRules?.applyLimit?.limit
            ? `You have <span>${
                studentFullRules?.applyLimit?.limit -
                  studentFullRules?.applyLimit?.used <
                0
                  ? 0
                  : studentFullRules?.applyLimit?.limit -
                    studentFullRules?.applyLimit?.used
              }</span> application chances left out of <span>${
                studentFullRules?.applyLimit?.limit
              }</span>`
            : `Are you sure to apply for this job?`
        }
        title={''}
        onApplyClick={onRoleAccept}
        confirm={false}
        applyText={'Apply'}
        dynamicContent={true}
      />

      <ConfirmationModal
        onCloseClick={() => onConfirmModalClose()}
        open={externalConfirm}
        description={`To apply for this  ${
          selectedRoleDetails?.rolePublishedBy === 'INSTITUTE'
            ? checkJobCategory(selectedRoleDetails?.jobCategory)
            : checkJobTypeLevel(
                selectedRoleDetails?.jobTypeLevels,
                selectedRoleDetails?.yearOfExperience
              )
        }, you must use their company site. Open a new window? `}
        title={''}
        onApplyClick={onExternalRedirect}
        confirm={false}
      />

      <ConfirmationModal
        onCloseClick={() => onExternalApplyClose()}
        open={externalLinkApply}
        description={`Did you apply for the "${
          selectedRoleDetails?.tittle
        }" position on ${
          selectedRoleDetails?.companyName ||
          selectedRoleDetails?.corporate?.name
        } company site? `}
        title={''}
        onApplyClick={onExternalApply}
        confirm={false}
      />
      <SuccessModal
        open={appliedSuccessModal}
        message={'Applied'}
        onCloseClick={() => onCloseCofirmApplied()}
        title={''}
      />
    </>
  )
}
export default SingleListed
